// Auto-generated by scripts/generate-registry.mjs from packages/modules/text_keychain/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const text_keychain: ModuleSchema = {
  "id": "text_keychain",
  "uniqueId": "B3D_79KCH",
  "createdAt": "2026-10-02T00:00:00Z",
  "updatedAt": "2026-10-28T14:58:34.716Z",
  "label": "Lexi Loop",
  "description": "Custom 3D text keychain with smart offset border fit and a solid split ring.",
  "category": "accessories",
  "tags": [
    "keychain",
    "text",
    "custom",
    "accessories"
  ],
  "sliders": [
    {
      "key": "fontSize",
      "label": "Font Size",
      "min": 10,
      "max": 50,
      "default": 24,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "baseThickness",
      "label": "Base Plate Thickness",
      "min": 0.1,
      "max": 8,
      "default": 3,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "baseOffset",
      "label": "Base Border Margin",
      "min": 2,
      "max": 10,
      "default": 4,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "textHeight",
      "label": "Raised Text Height",
      "min": 0.1,
      "max": 6,
      "default": 2,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "letterSpacing",
      "label": "Letter Spacing",
      "min": -10,
      "max": 40,
      "default": 0,
      "step": 1,
      "unit": "%",
      "enabled": true,
      "visible": true
    },
    {
      "key": "keychainLoop",
      "label": "Keyring Loop",
      "min": 0,
      "max": 1,
      "default": 1,
      "step": 1,
      "integerOnly": true,
      "unit": "",
      "enabled": true,
      "visible": true
    },
    {
      "key": "loopOuterD",
      "label": "Keyring Outer Diameter",
      "min": 7,
      "max": 16,
      "default": 10,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "loopInnerD",
      "label": "Keyring Hole Diameter",
      "min": 3,
      "max": 8,
      "default": 5,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "generateParts",
      "label": "Part Export Mode (0=Both, 1=Base, 2=Text)",
      "min": 0,
      "max": 2,
      "default": 0,
      "step": 1,
      "integerOnly": true,
      "unit": "",
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [
    {
      "key": "text",
      "label": "Custom Text (multi-line)",
      "default": "ALEX",
      "kind": "textarea",
      "enabled": true,
      "visible": true
    },
    {
      "key": "fontStyle",
      "label": "Font Family",
      "default": "varela",
      "kind": "font",
      "enabled": true,
      "visible": true
    }
  ],
  "colorConfigs": [
    {
      "key": "base_plate",
      "label": "Offset Border Base & Split Ring",
      "default": "#1E293B",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "text_letters",
      "label": "3D Raised Letters",
      "default": "#38BDF8",
      "targetGroupIds": [
        1
      ]
    }
  ],
  "objects": [
    {
      "id": "obj_base",
      "label": "Base Plate Assembly",
      "name": "Base Plate Assembly",
      "color": "#1E293B",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "base_plate",
          "label": "Offset Border Base & Split Ring",
          "name": "Offset Border Base & Split Ring",
          "groupId": 0,
          "colorKey": "base_plate",
          "defaultColor": "#1E293B",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    },
    {
      "id": "obj_text",
      "label": "3D Raised Text Assembly",
      "name": "3D Raised Text Assembly",
      "color": "#38BDF8",
      "assembled_z_offset": 0,
      "exploded_z_offset": 20,
      "parts": [
        {
          "id": "text_letters",
          "label": "3D Raised Letters",
          "name": "3D Raised Letters",
          "groupId": 1,
          "colorKey": "text_letters",
          "defaultColor": "#38BDF8",
          "assembled_z_offset": 0,
          "exploded_z_offset": 20,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Full Assembly"
    }
  ]
};
